import { UploadOutlined } from '@ant-design/icons';
import {
  Datatype,
  FileTypeRule,
  IRuleType,
  IWidgetType,
  MaxDimensionRule,
  NeedSignRule,
  RequiredRule,
  WidgetCategory,
  WidgetMainType,
  getSimpleWidgetReference,
  tran,
} from '@framework/engine';
import React from 'react';
import { IUploadWidget, WidgetUploadType } from './IUploadWidget';
import { UploadWidgetComponent } from './UploadWidgetComponent';
import {
  UploadWidgetConfigComponent,
  uploadInputConfigSchema,
} from './UploadWidgetConfigComponent';
import { UploadWidgetPreview } from './UploadWidgetPreview';
import { UploadWidgetReadonlyComponent } from './UploadWidgetReadonlyComponent';
import { createUplaodWidgetFormSchema } from './createUploadWidgetFormSchema';
import { hydrateUploadWidget } from './hydrateUploadWidget';

declare module '@framework/engine/src/schema/widgets/Widget' {
  export enum WidgetType {
    Upload = 'upload',
  }
}

export function publicDataUploadWidgetName(path: string) {
  return `${path}@publicData`;
}

export const UploadWidgetType: IWidgetType<IUploadWidget> = {
  type: WidgetUploadType,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  name: 'Campo Upload',
  icon: <UploadOutlined />,
  hasValue: true,
  hydrate: hydrateUploadWidget,
  getReference: getSimpleWidgetReference(Datatype.File),
  formComponent: UploadWidgetComponent,
  createFormSchema: createUplaodWidgetFormSchema,
  previewComponent: UploadWidgetPreview,
  configValidator: uploadInputConfigSchema,
  configComponent: UploadWidgetConfigComponent,
  readonlyComponent: UploadWidgetReadonlyComponent,
  translationSchema: tran.widget({
    label: tran.rte(),
    helpText: tran.rte(),
    title: tran.rte(),
    publicUploadTitle: tran.rte(),
    publicUploadLabel: tran.rte(),
    publicHelpText: tran.rte(),
    rules: tran.rules(),
  }),
  configOptions: {
    removeCollapsePanel: true,
  },
  // Facciamo un cast a IRuleType perché MaxDimensionRule non ha tutti i campi
  // opzionali (vedi .default() su value), richiesti dal tipo. Col cast evitiamo
  // errori di TS.
  rules: [
    RequiredRule,
    NeedSignRule,
    MaxDimensionRule,
    FileTypeRule,
  ] as IRuleType[],
};
